<template>
  <a-modal
  :maskClosable="false"
    :visible="visible"
    :title="`确认要删除“${record.name}”吗？`"
    :confirmLoading="confirmLoading"
    @ok="save"
    @cancel="cancel"
    destroyOnClose
  >
  </a-modal>
</template>
<script>
export default {
  props: {
    record: Object, // 当前行的数据
    vm: Object, // 触发这个action的组件对象，通常为modelTable或modelTree
    fields: Array, // 当前model的fields对象
    model: Object, // 当前model对象
    className: String, // 当前model的className
    modelName: String, // 当前model的名称
    category: String // 假如当前model显示为category格式，则会将当前的值传入
  },
  data () {
    return {
      confirmLoading: false,
      visible: true
    }
  },
  methods: {
    async save () {
      let isError = false
      this.$loading.show()
      this.confirmLoading = true
      try {
        const res = await this.$tkParse.get('/classes/hierarchy', {
          params: {
            where: {
              parent: this.record.objectId
            }
          }
        })
        if (res.data.results.length > 0) {
          this.$notification['error']({
            message: '操作失败',
            description: '该层级下有下属层级，请先将其移除。'
          })
          isError = true
          throw new Error('has level')
        }
        const users = await this.$tkParse.get('/classes/_User', {
          params: {
            where: {
              hierarchy: this.record.objectId
            }
          }
        })
        if (users.data.results.length > 0) {
          this.$notification['error']({
            message: '操作失败',
            description: '该层级下有账号，请先将其移除。'
          })
          isError = true
          throw new Error('has user')
        }
        await this.$tkParse.delete(`/classes/hierarchy/${this.record.objectId}`)
        this.vm.refresh()
        this.$notification['success']({
          message: '操作成功',
          description: '数据删除成功'
        })
        this.visible = false
        this.$emit('complete')
      } catch (e) {
        console.log(e)
        if (!isError) {
          this.$notification['error']({
            message: '操作失败',
            description: '操作失败，请重试'
          })
        }
      }
      this.confirmLoading = false
      this.$loading.hide()
    },
    cancel () {
      this.visible = false
    }
  }
}
</script>
<style scoped>
::v-deep .ant-modal-body{
  display: none;
}
::v-deep .ant-modal-header{
  border: none;
}

::v-deep .ant-modal-footer{
  border: none;
}
</style>
